import { render, staticRenderFns } from "./NhlTopPlayer.vue?vue&type=template&id=367d69d2&scoped=true"
import script from "./NhlTopPlayer.vue?vue&type=script&lang=js"
export * from "./NhlTopPlayer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "367d69d2",
  null
  
)

export default component.exports